import React from 'react';
import { useEffect, useState } from 'react';


import "./Kubernetes.css"
import { Back } from '../../../../../../../../../components/back/Back';
import { get_project_name } from '../../../../../../../../../utils/project';

const Kubernetes = ({ projectId, serviceName, setDeployment, next, preSetting, back, direction }) => {
    const [currentPage, setCurrentPage] = useState(direction === "forward" ? "component-type" : "component-setting") // experimantal
    const [settings, setSettings] = useState(Object.keys(preSetting).length > 2 ? preSetting : {
        infrastructure_type: "KubernetesDeployment",
        connector_id: preSetting.connector_id,
        port: 5000,
        namespace: "", // project 
        app: serviceName,
        include_autoScale: true,
        include_service: true,
        max_replicas: 3,
        min_replicas: 1,
        include_pv: false,
        pv_storage_class: "local-path",
        pv_storage_path: `/data/dbs-local-storage/${serviceName}`,
        pv_mount_path: "/app",
        storage_amount: "1Gi",
        variables: [

        ] 
    })

    const toNext = () => {
        setDeployment(settings)
        next()
    }
    useEffect(()=>{
        get_project_name((projectName)=>setSettings({...settings, namespace: projectName}), projectId);
    }, [])


    useEffect(()=>
    {
        setCurrentPage(direction === "forward" ? "component-type" : "component-setting")
    },
    [direction])
    return (
            <div className='new-service-deployment-setting-kubernetes'>
                <h1>Kubernetes</h1>
                {
                    currentPage ==="component-type" ? <div>    
                        <Back back={back}/>
                        <div className='info-blocks'>
                            <div className='info-block'>
                                <label>Component Type:</label>
                                <select onChange={(e)=>{setSettings({...settings,  infrastructure_type: e.target.value})}}>
                                    <option value="KubernetesDeployment">Deployment</option>
                                </select>
                            </div>
                        </div>
                        <button className='next-button' onClick={(e)=>{e.preventDefault();setCurrentPage("component-setting")}}>next</button>
                    </div> :
                    currentPage ==="component-setting" && settings.infrastructure_type === "KubernetesDeployment" ?
                        
                        <div className='kubernetes-deploymet-settings'>
                            <Back back={(e)=>{e.preventDefault();setDeployment(settings);setCurrentPage("component-type")}}/>
                            <div className='main-data'>
                                <div className='info-blocks'>
                                    <label>
                                        Port:
                                        <input 
                                            className='port-input'
                                            type="text" 
                                            value={settings.port || 0} 
                                            onChange={(e) => setSettings({ 
                                                ...settings, 
                                                port: parseInt(e.target.value, 10) 
                                            })}
                                        />
                                        
                                    </label>
                                    <label className='info-block'>Include:</label>
                                    <div className='component-choise-list'>
                                        <label>
                                            <input className='checkbox'
                                                checked={settings.include_service}
                                                type="checkbox" 
                                                onChange={(e) => setSettings({ 
                                                    ...settings, 
                                                    include_service: e.target.checked 
                                                })} 
                                            />
                                            Service
                                        </label>
                                        <label>
                                            <input className='checkbox'
                                                checked={settings.include_autoScale}
                                                type="checkbox" 
                                                onChange={(e) => setSettings({ 
                                                    ...settings, 
                                                    include_autoScale: e.target.checked 
                                                })} 
                                            />
                                            Auto scale (HPA)
                                        </label>
                                    </div>
                                </div>
                                {settings.include_autoScale && 
                                    <div className='autoscale_setting'>
                                        <label>Replicas:</label>
                                        <div className='replicas'>
                                            <label className='info-block'>
                                                min:
                                                <input className='replicas-amount'
                                                    type="number" 
                                                    value={settings.min_replicas} 
                                                    onChange={(e) => setSettings({ 
                                                        ...settings,
                                                        min_replicas: parseInt(e.target.value, 10) 
                                                    })} 
                                                />
                                            </label>
                                            <label className='info-block'>
                                                max:
                                                <input className='replicas-amount'
                                                    type="number" 
                                                    value={settings.max_replicas} 
                                                    onChange={(e) => setSettings({ 
                                                        ...settings, 
                                                        max_replicas: parseInt(e.target.value, 10) 
                                                    })} 
                                                />
                                            </label>
                                        </div>
                                    </div>}
                            </div>
                            <button className='next-button' onClick={(e)=>{e.preventDefault();toNext()}}>next</button>
                        </div>
                    : <div/>
                }
            </div>
        );
};

export default Kubernetes;